'use client'

import { Category } from '@/features/categories/model/category.model'
import { useTranslations } from 'next-intl'
import { CategoriesList } from '../category-list'

type Props = {
  categories: Category[]
}
export const Categories = ({ categories }: Props) => {
  const t = useTranslations()

  return (
    <article className='my-10'>
      <h2 className='mb-6 text-2xl font-semibold'>
        {t('products.storeCategories')}
      </h2>
      {/* <div className='flex flex-wrap justify-center gap-5 lg:justify-start'>
        {categories.map(category => (
          <CategoryItem key={category.id} category={category} />
        ))}
      </div> */}
      <section className='mx-auto'>
        <CategoriesList categories={categories} />
      </section>
    </article>
  )
}
